import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import StickyMobileCTA from "./components/StickyMobileCTA";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import AppLanding from "./pages/AppLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Pre-launch: shop route redirects to home product section */}
          <Route path="/shop" element={<Shop />} />
          {/* Permanent QR-code destination — never change this URL */}
          <Route path="/app" element={<AppLanding />} />
        </Routes>
        <Footer />
        <StickyMobileCTA />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: { fontFamily: "'Outfit', sans-serif" },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
